<template>
    <div class="phone-inline">
        <div class="form-group row inline-form" v-bind:class="{ 'has-danger' : error !== null }">
            <label class="col-md-3 col-xl-2 col-sm-12 col-form-label" :for="name">{{ uLang('app.' + name) }}: </label>
            <div class="col-md-9 col-xl-10 col-sm-12">
                <div class="row">
                    <div class="col-xl-2 col-lg-4 col-md-4 col-sm-4">
                        <backend-select no-form-group return="name" country inputHolderClasses="col-12" :resultMap="callCodeMap" label="" valueKey="name" :value="call_code" v-model="call_code" name="call_code" :route="route('admin.countries.index')"></backend-select>
                    </div>
                    <div class="col-xl-10 col-lg-8 col-md-8 col-sm-8">
                        <input type="text" class="form-control inline-input" name="phone_number" v-model="phone_number" maxlength="20">
                    </div>
                </div>
                <span class="help-block form-control-feedback" v-if="error != null" v-text="error"></span>
            </div>
        </div>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'

    export default {
        // ===Component name
        name: "form-phone-number",
        // ===Props passed to component
        props: {
            error: {
                type: String,
                required: false,
                default: null,
            },
            name: {
                required: true,
                type: String,
            },
            phoneNumber: {
                type: Object,
                default: null,
            }
        },
        // ===Components used by this component
        components: {
            Multiselect
        },
        // ====component Data properties
        data(){
            return {
                call_code: '+31',
                phone_number: '',
            };
        },
        watch: {
            inputWatchers() {
                this.$emit('input', { call_code: this.call_code, number: this.phone_number})
            },
            phoneNumber: function(val, oldVal) {
                if (val.phone_number != oldVal.phone_number && val.call_code != oldVal.call_code) {
                    this.phone_number = this.phoneNumber.phone_number
                    this.call_code = this.phoneNumber.call_code
                }
            }
        },
        // ===Code to be executed when Component is mounted
        mounted() {

        },
        created: function() {
            this.call_code = this.phoneNumber.call_code
            this.phone_number = this.phoneNumber.phone_number
        },
        // ===Computed properties for the component
        computed: {
            inputWatchers() {
                this.call_code;
                this.phone_number;
                return Date.now()
            },
        },
        // ===Component methods
        methods: {
            callCodeMap(countries) {
                return countries.map((country) => {
                    country.name = '+' + country.calling_code;
                    return country
                })
            },
        }
    }
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped>
    .select-holder{
        padding-left: 15px;
    }
    .form-group.inline-form > .multiselect .multiselect__option--highlight:after{
        display: none!important;
    }
    .form-group.inline-form .multiselect{
        display: inline-block;
        width: auto;
    }
    .form-group.inline-form input.inline-input{
        /*display: inline-block;*/
        /*width: 100%;*/
        /*float: right;*/
        /*position: relative;*/
    }

    @media screen and (max-width: 550px) {
        .form-group.inline-form .multiselect,
        .form-group.inline-form input.inline-input{
            width: 100%;
            display: block;
        }
        .form-group.inline-form .multiselect{
            margin-bottom: 5px;
        }
    }
</style>